export const isValidUrl = (string: string): boolean => {
	try {
		return Boolean(new URL(string));
	} catch (e) {
		return false;
	}
};
